export default "__VITE_ASSET__MogPIqXY__"